import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../lastProjects/LastProjects.css";
import "./Notifications.css";

function formatTime(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleString();
}

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  useEffect(() => {
    if (!token) return;
    const fetchAll = async () => {
      setLoading(true);
      try {
        const [ordersRes, messagesRes] = await Promise.all([
          axios.get("/orders", {
            params: { limit: 30 },
            headers: { Authorization: `Bearer ${token}` },
          }).catch(() => ({ data: { orders: [] } })),
          axios.get("/messages", {
            params: { limit: 50 },
            headers: { Authorization: `Bearer ${token}` },
          }).catch(() => ({ data: { messages: [] } })),
        ]);

        const orders = ordersRes?.data?.orders ?? [];
        const messages = messagesRes?.data?.messages ?? [];

        const items = [];

        orders.forEach((order) => {
          items.push({
            id: `order-${order._id}`,
            type: "order",
            title: "Order",
            text: `Order from ${order.customer?.fullName || "Customer"} • ${order.status || "pending"}`,
            link: `/dashboard/orders/${order._id}`,
            createdAt: order.createdAt,
          });
        });

        messages.forEach((msg) => {
          items.push({
            id: `message-${msg._id}`,
            type: "message",
            title: msg.isRead ? "Message" : "New message",
            text: `${msg.name}: ${(msg.message || "").slice(0, 80)}${(msg.message || "").length > 80 ? "…" : ""}`,
            link: "/dashboard/messages",
            createdAt: msg.createdAt,
            unread: !msg.isRead,
          });
        });

        items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setNotifications(items);
      } catch (err) {
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, [token]);

  if (loading) {
    return (
      <main className="lastProjects dashboard-notifications">
        <div className="container">
          <div className="dashboard-notifications-loading">Loading notifications...</div>
        </div>
      </main>
    );
  }

  return (
    <main className="lastProjects dashboard-notifications">
      <div className="container">
        <header className="dashboard-notifications-header">
          <h1>All Notifications</h1>
          <p>Orders and messages in one place</p>
        </header>

        <section className="dashboard-notifications-list">
          {notifications.length === 0 ? (
            <div className="dashboard-notifications-empty">
              <i className="uil uil-bell-slash" aria-hidden />
              <p>No notifications yet</p>
              <Link to="/dashboard">Back to dashboard</Link>
            </div>
          ) : (
            notifications.map((n) => (
              <Link
                key={n.id}
                to={n.link}
                className={`dashboard-notifications-card ${n.unread ? "unread" : ""}`}
              >
                <div className="dashboard-notifications-card-icon">
                  <i
                    className={
                      n.type === "order" ? "uil uil-shopping-cart" : "uil uil-message"
                    }
                    aria-hidden
                  />
                </div>
                <div className="dashboard-notifications-card-content">
                  <span className="dashboard-notifications-card-title">{n.title}</span>
                  <span className="dashboard-notifications-card-text">{n.text}</span>
                  <span className="dashboard-notifications-card-time">
                    {formatTime(n.createdAt)}
                  </span>
                </div>
                <i className="uil uil-arrow-right dashboard-notifications-card-arrow" aria-hidden />
              </Link>
            ))
          )}
        </section>
      </div>
    </main>
  );
}

export default Notifications;
